import _tmpl from "./toast.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Variant = /*#__PURE__*/function (Variant) {
  Variant["Default"] = "default";
  return Variant;
}({});
let Theme = /*#__PURE__*/function (Theme) {
  Theme["Info"] = "info";
  Theme["Warning"] = "warning";
  Theme["Error"] = "error";
  Theme["Success"] = "success";
  Theme["Inactive"] = "inactive";
  return Theme;
}({});
class Toast extends LightningElement {
  constructor(...args) {
    super(...args);
    this.ariaLabel = null;
    this.ariaLive = null;
    // aria for the close button
    this.closeAriaLabel = null;
    this.closeAriaLive = null;
    this.variant = Variant.Default;
    this.theme = Theme.Info;
    this.toastAction = "";
    this.toastTitle = void 0;
    this.toastMessage = void 0;
    this.toastActionMessage = void 0;
    this.hideCloseAction = false;
    this.hideIcon = false;
    this.inlineAction = false;
    this.icon_map = {
      info: "info",
      warning: "warning",
      error: "error",
      success: "success",
      inactive: "info"
    };
  }
  get classes() {
    return classNames("element", {
      [`variant-${this.variant}`]: Object.values(Variant).includes(this.variant),
      [`theme-${this.theme}`]: Object.values(Theme).includes(this.theme)
    }, this.hideIcon && "no-icon");
  }
  handleClose() {
    const closeToastEvent = new CustomEvent("close", {
      bubbles: true
    });
    this.dispatchEvent(closeToastEvent);
  }
  handleToastAction(event) {
    if (!this.toastAction) {
      event.preventDefault();
    }
    const toastActionEvent = new CustomEvent("toastaction", {
      bubbles: true
    });
    this.dispatchEvent(toastActionEvent);
  }
  get icon() {
    return this.icon_map[this.theme];
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Toast, {
  publicProps: {
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    closeAriaLabel: {
      config: 0
    },
    closeAriaLive: {
      config: 0
    },
    variant: {
      config: 0
    },
    theme: {
      config: 0
    },
    toastAction: {
      config: 0
    },
    toastTitle: {
      config: 0
    },
    toastMessage: {
      config: 0
    },
    toastActionMessage: {
      config: 0
    },
    hideCloseAction: {
      config: 0
    },
    hideIcon: {
      config: 0
    },
    inlineAction: {
      config: 0
    }
  },
  fields: ["icon_map"]
});
const __lwc_component_class_internal = _registerComponent(Toast, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;